<template>
  <div class="mainmenu w-full font-bold relative">
    <WFPageMenu ref="menu" :showIcon="true" class="w-full h-full" :currentPage="currentPage" @clicked="pageSelected"></WFPageMenu>
    <NavBar v-show="navbar" class="absolute top-0 bottom-0 w-full h-full bg-base"></NavBar>
  </div>
</template>

<script>
//import { WFGroupsMenu } from '@3dwayfinder/wayfinder-vue-components'
import { mapState } from "vuex";
import NavBar from "./NavBar.vue";

export default {
  components: {
    NavBar
  },
  computed: {
    ...mapState("wf", ["landscape"]),
    ...mapState(["currentPage", "navbar", "currentTab"]),
  },
  watch: {
    currentTab() {
      this.setPageBySlug(this.currentTab)
    }
  },
  methods: {
    pageSelected(page) {
      this.$store.dispatch("setPOI", null);
      this.$store.dispatch("setTab", page.slug);
    },
    setPageBySlug(slug) {
      if (typeof slug === "string" && this.$refs.menu) {
        let page = this.$refs.menu.findBySlug(slug);
        
        this.$store.dispatch("setPage", page);
      }
    }
  },
};
</script>

<style lang="postcss">

  .mainmenu {
    border-top: solid 0.1rem var(--th-border);
  }

  .mainmenu .wf-page-menu .wf-list {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    gap: 2.8rem;
    padding: 1.6rem 3.2rem;
  }

  .mainmenu .wf-list-item {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-basis: 11.5rem;
    padding: 0.8rem 1.6rem;
    gap: 0.8rem;
    text-transform: uppercase;
    font-size: 1.2rem;
    align-items: center;
  }

  .mainmenu .wf-active {
    background-color: var(--th-active);
    border-radius: 0.4rem;
  }

  .mainmenu .wf-page-menu .wf-icon, .mainmenu .wf-page-menu .wf-icon svg {
    height: 3.2rem;
    width: 3.2rem;
  }
</style>
